module.exports = __webpack_public_path__ + "static/media/uk-flag.78e7b72e.svg";